module.exports = __webpack_public_path__ + "2e16d0d4ea2da77b496f5b49e82118c8.jpg";